<template lang="pug">
h1
  template(v-for="(breadcrumb, index) in breadcrumbs")
    router-link(v-if="breadcrumb.path && index !== breadcrumbs.length-1" :to="{path: breadcrumb.path}") {{ $t(breadcrumb.name) }}
    span(v-else :class="{pan: index !== breadcrumbs.length-1}") {{ localizeSafely(breadcrumb.name) }}
    span.separate(v-if="index !== breadcrumbs.length-1") /

</template>

<script>
export default {
  computed: {
    breadcrumbs: function() {
      return this.$store.state.global.breadcrumbs
    }
  },
  methods: {

    // ローカライズ可能な文字列のみ変換
    localizeSafely(text) {
      if(text.match(/\./)) {
        return this.$t(text)
      } else {
        return text
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
